import { getWindow } from "./armor-system-4JVSZEDO.js";

// src/util/compatibility.ts
var win = getWindow();
var RESIZE_OBSERVER_SUPPORTED = win ? "ResizeObserver" in window : false;
export { RESIZE_OBSERVER_SUPPORTED };